<information-detail-tag>
<style>
a {
  color: #00894B
}
</style>

<div class="container_breadcrumb">
  <ul class="breadcrumb">
    <li class="breadcrumb-item"><a href="/menu/information" class="news">お知らせ</a></li>
    <li class="breadcrumb-item"><h1>詳細</h1></li>
  </ul>
</div><!--/.container_breadcrumb-->

<div class="contents">
  <section class="contents_area">
    <div class="contents_block detail">
      
      <div class="wrap_news-info">
        <p class="wrap_news-info-date">{state.info.created_at}</p>
        <span class="label {informationLabel(state.info.service)}"></span>
      </div><!--/.wrap_news-info-->
      <div class="container_news-title">{state.info.title}</div><!--/.container_news-title-->
      
      <p class="text margin-spacing-2_bottom" style="white-space: pre-wrap;"><raw-tag html={convertLink(state.info.body)}></raw-tag></p>
    </div><!--/.contents_block-->
  </section><!--/.contents_area-->
</div><!--/.contents-->

<script>
  import di from "dependency-injection";
  import InformationLabel from "@model/information-label.js";
  export default {
    informationLabel: InformationLabel.get,
    informationId: false,
    state: {
      info: {},
    },
    convertLink(body){
      if (!body) { return ''}
      return body.replace(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig,"<a href='$1'>$1</a>");
    },
    back(e){
      e.preventDefault();
      history.back();
    },
    onBeforeMount(props, state){
      this.api = di.createApi('menu');
      this.api.request('information', 'detail', {id: props.routeParams[0]})
        .then(data => this.update({info: data}));
    }
  }
</script>
</information-detail-tag>
